import { createContext } from "react";

/**
 * The `OverlayContext` value.
 */
export interface OverlayContextValue {

  /**
   * Gets the current overlay context element.
   */
   readonly element: HTMLElement | null;
}

/**
 * The overlay context.
 */
export const OverlayContext = createContext<OverlayContextValue>({
  element: null,
});
